import Axios from 'axios'

import { Datadog } from '../Global/Datadog'
import { Segment } from '../Global/Segment'
import { SegmentEvents } from '../Global/SegmentEvents'
import { isSessionTokenExpired } from '../reducers/token'
import { logout } from '../utils'

export const applyInterceptors = () => {
  Axios.interceptors.request.use(
    (config) => {
      const isSessionExpired = isSessionTokenExpired()
      // When a session expires, but the UI still lives in the browser, the next
      // action that call the API will fail and it's better to log out a user
      // rather than to allow an Oops page or a limbo with missing data in the state.
      if (isSessionExpired) {
        Datadog.addAction('logout', { reason: 'Session token expired' })
        logout(isSessionExpired)
      }

      return config
    },
    (error) => {
      return Promise.reject(error)
    },
  )

  Axios.interceptors.response.use(
    (response) => {
      return response
    },
    (error) => {
      if (error.response === undefined && error.message === 'Network Error') {
        // sadly, it's impossible to distinguish e.g. CORS issues, so we can
        // only register all network errors (whether it's no internet connection,
        // cors, dns problems or something else)
        Segment.track(SegmentEvents.debug.networkError, {
          error_message: error?.message,
          api_url: error?.config?.url || error?.request?.responseURL,
          request_absolute_url: error?.request?.responseURL,
          window_absolute_url: window.location.href,
          ...(error.response?.headers ? { responseHeaders: error.response?.headers } : {}),
        })
        return Promise.reject(error)
      }

      if (error.response?.status === 401) {
        Datadog.addAction('logout', { reason: 'API response: 401' })
        logout()
      } else if (error.response?.status === 429) {
        /*
       When rate limiting kicks in we cannot guarantee system stability
       hence the safest thing is to reload the page to get the 429.html form spoe
       otherwise something might continue making requests in the background and the limit will never go away
       */
        window.location.reload()
      } else if (error.response?.status === 405) {
        Segment.track(SegmentEvents.debug.methodNotAllowedError, {
          error_message: error?.message,
          api_url: error?.config?.url || error?.request?.responseURL,
          request_absolute_url: error?.request?.responseURL,
          window_absolute_url: window.location.href,
          ...(error.response?.headers ? { responseHeaders: error.response?.headers } : {}),
        })
      }
      return Promise.reject(error)
    },
  )
}
